/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Col_PremiereInputs */

const en_fc_cmp_col_premiere = /** @type {(inputs: Fc_Cmp_Col_PremiereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe Premiere Pro`)
};

/**
* | output |
* | --- |
* | "Adobe Premiere Pro" |
*
* @param {Fc_Cmp_Col_PremiereInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_col_premiere = /** @type {((inputs?: Fc_Cmp_Col_PremiereInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Col_PremiereInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_col_premiere(inputs)
});
export { fc_cmp_col_premiere as "fc.cmp.col.premiere" }